<?php

\Core\View::$template = function () {

    $html = '<div class="container"><div class="row">';
    $html_favorite = '';
    $pv = \Core\View::$page_vars;
    \ISOPHP\js_core::$console->log('pagevars: ', $pv);
    $rqd = $pv['request_data'];
    $rqd_user_logged = $rqd['user_logged'];
    \ISOPHP\js_core::$console->log('logged user id: ', $rqd_user_logged);

    foreach ($rqd['jobs'] as $one_job) {
        $html = $html . '            
                <div class="col-sm-6 col-md-6 col-xs-12 col-12">
                    <div class="one_account">
                        <span id="job_' . $one_job['id'] . '" class="edit_job_btn btn go-edit-job"><i class="fa fa-pencil"></i></span>
                        <div class="row clearfix">
                            <div class="col-sm-12">
                                <p class="job_id_title">Job ID: <span class="job_id">' . $one_job['id'] . '</span></p>
                            </div>
                        </div>
                        <div id="job_' . $one_job['id'] . '" class="row jobs-details">
                            <div class="col-sm-12">
                                <h6 class="job_title list_job_title">' . $one_job['title'] . '</h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="label_wrap">
                                    <p class="job_lebels job_job_type"><i class="fa fa-graduation-cap"></i>' . $one_job['job_type'] . '</p>
                                    <p class="job_lebels job_job_level"><i class="fa fa-briefcase  "></i>' . $one_job['job_level'] . '</p>
                                    <p class="job_lebels job_location"><i class="fa fa-map-marker"></i>' . \ISOPHP\core::$php->explode(',', $one_job['job_location'])[0] . '</p>
                                    <p class="job_lebels job_applicant"><i class="fa fa-user"></i>' . $one_job['applied_count'] . '</p>
                                </div>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <p class="job_description">' . substr($one_job['description'],0,100).(strlen($one_job['description']) > 100 ? " ...." : ""). '</p>
                            </div>
                        </div> ';
        // if(!empty($one_job['thoseapplied'])){
        //     $html = $html . '
        //                 <div class="row">
        //                     <div class="col-sm-12">
        //                         <div class="label_wrap">';
        //     foreach ($one_job['thoseapplied'] as $applicant) {
        //         $html = $html . '<p class="btn btn-link applicant-profile" id="see_profile_'. $applicant['appliedinfo']['id'] .'">' . $applicant['appliedinfo']['full_name'] . '</p>';
        //     }
        //     $html = $html . '                                    
        //                         </div>
        //                     </div>
        //                 </div>  ';
        // }

        
        $html = $html . '
                    </div>
                </div> ';

    }
    $html = $html . '</div></div>';

    return $html;

};


// WEBPACK FOOTER //
// app/JobList/View/MyJobs.php